import { debounce } from './debounce';
import { mobileCheck } from './mobile-check';

window.addEventListener('load', event => {
    let maxWidth = window.matchMedia('(max-width: 539px)');
    let tabletWidth = window.matchMedia('(min-width: 540px)');
    let laptopWidth = window.matchMedia('(min-width: 1024px)');
    let desktopWidth = window.matchMedia('(min-width: 1540px)');
    let video = document.getElementById('fitafy-video');
    let source = document.getElementById('fitafy-video-source');

    let getUrl = window.location;
    let baseUrl = getUrl.protocol + '//' + getUrl.host + '/' + getUrl.pathname.split('/')[1];

    if (video) {
        screenResCheck(maxWidth, tabletWidth, laptopWidth, desktopWidth, video, source, baseUrl);
    }

    let myDebounceVar = debounce(function() {
        screenResCheck(maxWidth, tabletWidth, laptopWidth, desktopWidth, video, source, baseUrl);
    }, 250);

    if (!mobileCheck && video != null) {
        window.addEventListener('resize', myDebounceVar);
    }
});

// Function that checks screen size for video
function screenResCheck(maxWidth, tabletWidth, laptopWidth, desktopWidth, video, source, baseUrl) {
    if (maxWidth.matches && video) {
        video.pause();
        source.src = baseUrl + '/build/fitafy/video/Fitafy_Mobile_1080x1920_Bkgnd_Vid.mp4';
        video.load();
        video.play();
    } else if (desktopWidth.matches && video) {
        video.pause();
        source.src = baseUrl + '/build/fitafy/video/Fitafy_Desktop_1920x1080_Bkgnd_Vid.mp4';
        video.load();
        video.play();
    } else if (laptopWidth.matches && video) {
        video.pause();
        source.src = baseUrl + '/build/fitafy/video/Fitafy_Laptop_1440x750_Bkgnd_Vid.mp4';
        video.load();
        video.play();
    } else if (tabletWidth.matches && video) {
        video.pause();
        source.src = baseUrl + '/build/fitafy/video/Fitafy_Laptop_1440x750_Bkgnd_Vid.mp4';
        video.load();
        video.play();
    } else {
        video = null;
    }
}
